import { AutoComplete, DatePicker, Form, Input, Select } from "antd";
import React, { createRef, useEffect, useRef, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import AddButton from "../../../../Componets/Buttons/add";
import { select_id, select_search } from "../../../../Controllers/Global";
import dayjs from "dayjs";
import moment, { max } from "moment";
import taxes from "../../../taxes.json";
import payment_types from "../../../payment_types.json";
import Error from "../../../../Componets/Error";
import Modalcomponent from "../../../../Componets/Modal";
import { get_inventory } from "../../../../Controllers/Inventory/Batch";
import { all } from "axios";
import {
  handleDateKeyDown,
  handleDateInput,
  handleDateBlur,
  blockPaste,
} from "../../../../Componets/Formcomponents/dateUtility";
import formatDateDDMMYYYY from "../../../../Main/formatDate";

const Salesreturntable = React.forwardRef((props, focus) => {
  const { details, setDetails, totals, setTotals, invoiceData } = props;


  useEffect(() => {
    if (invoiceData?.details && invoiceData.details.length > 0) {
      const populatedDetails = invoiceData.details.map((item, index) => {
        const descriptionId = item.description?._id || item._id;
        const unit = item.unit;
        const quantity = item.quantity || 1;
        const sale_price = item.sale_price || 0;
        const tax = item.tax || 0;
        const tax_amount = (sale_price * tax / 100) * quantity;
        const subtotal = quantity * sale_price;
        const total = subtotal + tax_amount;

        return {
          id: descriptionId,
          description: descriptionId,
          name: item.description?.product?.name || item.name,
          batch: item.description?.number || "N/A",
          expiry_date: item.description?.expiry_date || item.expiry_date,
          unit: unit,
          unit_name: item.unit_name || "",
          unit_details_options: item.unit_details_options || [],
          quantity: quantity,
          purchase: "",
          sale_price: sale_price,
          discount_percentage: item.discount_percentage,
          discount_price: item.discount_price,
          purchase_options: null,
          delivered: quantity,
          tax: tax,
          free: item.free || "",
          barcode: "",
          price_per_unit: "",
          expiry_date: item.description?.expiry_date || item.expiry_date,
          tax_amount: tax_amount.toFixed(3),
          total: item.total,
          stock: item.quantity,
          already_ordered_quantity: item.quantity,
          inventory_unit_details: item.inventory_unit_details || [],
          invoice_qty: item.quantity,
          max_available_qty: item.quantity,
          conversion: item.conversion || 1,
          subtotal: subtotal,
          options: []
        };
      });

      setDetails(populatedDetails);
    }
  }, [invoiceData, setDetails, setTotals]);

  focus.current[`delivery_date`] = createRef();
  focus.current[`payment_types`] = createRef();

  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [selectedModalData, setSelectedModalData] = useState();


  const handleSearch = (e, index) => {
    if (!invoiceData?.details) return;

    const options = invoiceData.details.map((item) => ({
      value: item._id,
      label: (
        <div>
          <div>{item.description?.product?.name || item.name}</div>
          <div>
            OMR {item.sale_price?.toFixed(3)}
            {` (#BATCH-${item.description?.number || "N/A"})`}
          </div>
          <div>
            UNIT: {item.unit_name || "Main"}
            {item.conversion > 1 ? ` (Conversion: ${item.conversion})` : ""}
          </div>
          {item.description?.expiry_date || item.expiry_date ? (
            <div>
              EXPIRY:{" "}
              {formatDateDDMMYYYY(item.description?.expiry_date || item.expiry_date)}
            </div>
          ) : null}
        </div>
      ),
    }));
    const data = [...details];
    data[index].options = options;
    setDetails(data);
  };

  const handleModal = (modaldata) => {
    let data = [...details];

    let inventory = selectedModalData;
    let index = selectedModalData?.index;

    let inventory_description = null;
    let inventory_name = "";
    let inventory_batch = "";
    let inventory_expiry_date = "";
    let inventory_price_per_unit = "";
    let inventory_unit = "";
    let inventory_unit_name = "";
    let inventory_sale_price = 0;
    let inventory_stock = 0;
    let inventory_tax = 0;
    let inventory_conversion = 0;
    let inventory_unit_details = [];

    let description_ids = [];

    data?.map((v, i) => {
      description_ids?.push(v?.unit);
    });

    if (!description_ids?.includes(modaldata)) {
      if (inventory?.data?._id == modaldata) {
        inventory_description = inventory?.data?._id;
        inventory_name = inventory?.data?.product?.name;
        inventory_batch = inventory?.data?.number;
        inventory_expiry_date = inventory?.data?.expiry_date;
        inventory_price_per_unit = inventory?.data?.price_per_unit;
        inventory_unit = modaldata;
        inventory_unit_name = inventory?.data?.product?.unit?.name;
        inventory_sale_price = inventory?.data?.sale_price;
        inventory_stock = inventory?.data?.stock;
        inventory_tax = inventory?.data?.tax;

        if (inventory?.data?.inventory_unit_details?.length > 0) {
          inventory?.data?.inventory_unit_details?.map((value, index) => {
            inventory_unit_details?.push({
              ...value,
              name: value?.name,
              purchase_price: value?.purchase_price,
              price_per_unit: value?.price_per_unit,
              sale_price: value?.sale_price,
              stock: value?.stock,
              unit_quantity: 0,
              unit_delivered: 0,
            });
          });
        }
      } else {
        let selected_unit = "";
        let unit_ids = [];

        if (inventory?.data?.inventory_unit_details?.length > 0) {
          inventory?.data?.inventory_unit_details?.map((value, index) => {
            unit_ids?.push(value?._id);
          });
        }

        if (unit_ids?.includes(modaldata)) {
          selected_unit =
            inventory?.data?.inventory_unit_details?.[
            unit_ids?.indexOf(modaldata)
            ];
        }

        inventory_description = inventory?.data?._id;
        inventory_name = inventory?.data?.product?.name;
        inventory_batch = inventory?.data?.number;
        inventory_expiry_date = inventory?.data?.expiry_date;
        inventory_unit = modaldata;
        inventory_unit_name = selected_unit?.name;
        inventory_sale_price = selected_unit?.sale_price;
        inventory_stock = selected_unit?.stock;
        inventory_tax = inventory?.data?.tax;
        inventory_conversion = selected_unit?.conversion;
      }

      data[index].description = inventory_description;
      data[index].name = inventory_name;
      data[index].batch = inventory_batch;
      data[index].expiry_date = inventory_expiry_date;
      data[index].unit = inventory_unit;
      data[index].unit_name = inventory_unit_name;
      data[index].quantity = "";
      data[index].sale_price = inventory_sale_price;
      data[index].stock = inventory_stock;
      data[index].tax = inventory_tax;
      data[index].conversion = inventory_conversion;
      data[index].unit_details_options = inventory_unit_details;

      focus.current[`quantity${index}`].current.focus();

      setDetails(data);
      setModalData();
      setSelectedModalData();
    } else {
      let selected_index = description_ids?.indexOf(inventory?.data?._id);

      if (
        parseFloat(data[selected_index].quantity || 0) <
        parseFloat(data[selected_index].stock || 0)
      ) {
        let quantity = data[selected_index].quantity
          ? data[selected_index].quantity
          : 0;

        if (
          data?.[selected_index]?.conversion > 0 &&
          data?.[selected_index]?.quantity + parseFloat(1) >=
          data?.[selected_index]?.conversion
        ) {
          toast?.error(
            `Quantity exceeding ${data?.[selected_index]?.conversion}`
          );
        } else {
          data[selected_index].quantity = parseFloat(quantity) + parseFloat(1);
          data[selected_index].delivered = parseFloat(quantity) + parseFloat(1);
        }

        setDetails(data);
        setModalData();
        setSelectedModalData();
      } else {
        toast?.error(`Stock only ${data[selected_index].stock}`);
      }
    }
  };

  const handleDescription = (selectedId, index) => {
    let data = [...details];

    const item = invoiceData.details.find(
      (d) => d._id === selectedId || d.description?._id === selectedId
    );

    if (!item) return toast?.error("Inventory not found");

    const productUnitKey = `${item.description?._id || item._id}-${item.unit}`;

    const existingProductIndex = data.findIndex((row, i) =>
      i !== index &&
      `${row.description}-${row.unit}` === productUnitKey
    );

    console.log("existingProductIndex", existingProductIndex, productUnitKey, data)

    if (existingProductIndex !== -1) {
      const existingRow = data[existingProductIndex];
      const currentQty = parseFloat(existingRow.quantity) || 0;

      const totalQuantityUsed = data.reduce((total, row, i) => {
        if (`${row.description}-${row.unit}` === productUnitKey) {
          return total + (parseFloat(row.quantity) || 0);
        }
        return total;
      }, 0);

      const maxAvailableQty = item.quantity;
      const remainingQty = maxAvailableQty - totalQuantityUsed;

      if (remainingQty > 0) {
        const newQty = currentQty + 1;

        if (newQty <= maxAvailableQty) {
          data[existingProductIndex].quantity = newQty;

          const sale_price = data[existingProductIndex].sale_price || 0;
          const tax = data[existingProductIndex].tax || 0;

          data[existingProductIndex].tax_amount = (sale_price * tax / 100) * newQty;
          data[existingProductIndex].total = (newQty * sale_price) + data[existingProductIndex].tax_amount;

          setDetails(data);

          data[index] = {
            id: "",
            description: null,
            name: "",
            unit: "",
            unit_name: "",
            unit_details_options: null,
            quantity: "",
            purchase: "",
            sale_price: "",
            purchase_options: null,
            delivered: "",
            tax: 0,
            free: "",
            barcode: "",
            price_per_unit: "",
            expiry_date: "",
            tax_amount: "0.000",
            total: 0,
          };

          setDetails(data);
          toast?.success(`Quantity increased to ${newQty} in row ${existingProductIndex + 1}`);

          setTimeout(() => {
            focus.current[`description${index}`].current.focus();
          }, 100);

          return;
        } else {
          toast?.error(`Total quantity for this product-unit cannot exceed ${maxAvailableQty}`);
          return;
        }
      } else {
        toast?.error(`Total quantity for this product-unit cannot exceed ${maxAvailableQty}`);
        return;
      }
    }

    const totalQuantityUsed = data.reduce((total, row, i) => {
      if (`${row.description}-${row.unit}` === productUnitKey) {
        return total + (parseFloat(row.quantity) || 0);
      }
      return total;
    }, 0);


    console.log("totalQuantityUsed", totalQuantityUsed, item);

    const maxAvailableQty = item.quantity;
    const remainingQty = maxAvailableQty - totalQuantityUsed;

    if (remainingQty <= 0) {
      toast?.error(`Total quantity for this product-unit cannot exceed ${maxAvailableQty}`);
      return;
    }

    data[index].description = item.description?._id || item._id;
    data[index].name = item.description?.product?.name || item.name;
    data[index].batch = item.description?.number || "N/A";
    data[index].expiry_date = item.description?.expiry_date || item.expiry_date;
    data[index].unit = item.unit;
    data[index].unit_name = item.unit_name || "";
    data[index].sale_price = item.sale_price;
    data[index].stock = item.quantity;
    data[index].already_ordered_quantity = item.quantity;
    data[index].unit_details_options = item.unit_details_options || [];
    data[index].inventory_unit_details = item.inventory_unit_details || [];
    data[index].invoice_qty = item.quantity;
    data[index].max_available_qty = remainingQty;
    data[index].conversion = item.conversion || 1;

    if (!data[index].quantity) {
      data[index].quantity = 1;
    }

    data[index].tax = item.tax;
    data[index].tax_amount = (item.sale_price * item.tax / 100) * data[index].quantity;
    data[index].subtotal = (data[index].quantity * item.sale_price);
    data[index].total = (data[index].quantity * item.sale_price) + data[index].tax_amount;

    setTotals({
      subtotal: data[index].subtotal,
      taxamount: data[index].tax_amount,
      total: data[index].total,
      payment_types: ["Cash"],
      payment_status: 2,
    });

    setDetails(data);
    focus.current[`quantity${index}`].current.focus();
  };

  const handlePurchasePriceSearch = async (e, index) => {
    let data = [...details];

    if (data[index].description) {
      const select = {
        api: "get-all-purchase-details",
        id: data[index].description,
      };

      const search = await select_id(select);
      if (search?.status) {
        let options = [];
        search?.data?.map((value, index) => {
          options?.push({
            value: JSON?.stringify(value),
            label:
              "" +
              value?.price_per_unit?.toFixed(3) +
              " (" +
              value?.purchase?.supplier?.name +
              ", " +
              formatDateDDMMYYYY(value?.purchase?.date) +
              ", #PO" +
              value?.purchase?.number +
              ")",
          });
        });

        data[index].purchase_options = options;
        setDetails(data);
      } else {
        toast?.error(search?.message);
      }
    }
  };

  const handleTotal = (e, index, key) => {
    let name = key ? key : e?.target?.name;
    let value = key ? e?.target?.value : e?.target?.value;

    value = parseFloat(value) || 0;

    let data = [...details];

    console.log("details", details, name)

    const currentDescription = data[index]?.description;
    const currentUnit = data[index]?.unit;

    if (!currentDescription) {
      toast.error("Please select a product first");
      return;
    }

    console.log("aihaknasnaksa", invoiceData)
    const originalItem = invoiceData.details.find(
      (d) => d._id === currentDescription || d.description?._id === currentDescription
    );

    if (!originalItem) return;

    const productUnitKey = `${currentDescription}-${currentUnit}`;
    let maxQty = 0;

    const matchingDetail = invoiceData.details.find(
      (d) => `${d.description?._id || d._id}-${d.unit}` === productUnitKey
    );

    if (matchingDetail) {
      maxQty = matchingDetail.quantity || 0;
    }

    let totalQuantityForProduct = 0;
    data.forEach((row, i) => {
      if (`${row.description}-${row.unit}` === productUnitKey) {
        if (i === index) {
          totalQuantityForProduct += value;
        } else {
          totalQuantityForProduct += (parseFloat(row.quantity) || 0);
        }
      }
    });

    if (totalQuantityForProduct > maxQty && name == "quantity") {
      toast.error(`Total quantity for this product-unit cannot exceed ${maxQty} (across all rows)`);
      return;
    }

    if (value >= 0) {

      if (
        parseFloat(value) > originalItem.free && name === "free"
      ) {
        toast?.error(`FOC Quantiy exceeding ${originalItem.free}`);
      } else {
        let data_sale_price = data[index]?.sale_price
          ? data[index]?.sale_price
          : 0;
        let data_quantity = data[index]?.quantity > 0 ? data[index]?.quantity : data[index]?.invoice_qty > 0 ? data[index]?.invoice_qty : 0;
        let data_deliverd = data[index]?.delivered ? data[index]?.delivered : 0;
        let data_free = data[index]?.free ? data[index]?.free : 0;
        let data_tax = data[index]?.tax ? data[index]?.tax : 0;
        let data_conversion = data[index].conversion ? data[index].conversion : 0;

        if (data_conversion > 1) {
          data_quantity = data_quantity / data_conversion;
        }

        let sale_price = name === "sale_price" ? value : data_sale_price;
        let quantity =
          name === "quantity"
            ? value
            : data_quantity;
        let delivered = name === "quantity" ? value : data_deliverd;
        let free = name === "free" ? value : data_free;
        let tax = name === "tax" ? value : data_tax;

        let tax_amount = tax
          ? parseFloat(sale_price) *
          parseFloat(quantity ? quantity : 0) *
          (parseFloat(tax) / 100)
          : 0;

        let total =
          parseFloat(sale_price) * parseFloat(quantity ? quantity : 0) +
          parseFloat(tax_amount);

        let price_per_unit =
          parseFloat(total ? total : 0) /
          (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

        let unit_details_options = [];
        if (data?.[index]?.unit_details_options?.length > 0) {
          data?.[index]?.unit_details_options?.map((v, i) => {
            let total_quantity =
              parseFloat(quantity || 0) + parseFloat(free || 0);

            unit_details_options?.push({
              ...v,
              price_per_unit: price_per_unit
                ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
                : 0,
              unit_quantity: quantity
                ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
                : 0,
              unit_delivered: delivered
                ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
                : 0,
            });
          });
        }

        const allowed =
          data_conversion > 1
            ? data[index]?.stock + data[index].free / data_conversion
            : data[index]?.stock + data[index].free;

        console.log("data_conversion", data_conversion, quantity, free, data[index], data[index]?.stock, allowed);



        if (
          data_conversion > 0 &&
          parseFloat(quantity) + parseFloat(free) > allowed && name === "quantity"
        ) {
          toast?.error(`Quantiy exceeding ${allowed}`);
        } else {
          data[index][name] = value;
          data[index].unit_details_options = unit_details_options;
          data[index].delivered = delivered ? delivered : "";
          data[index].tax = tax ? tax : 0;
          data[index].total = total ? total : 0;
          data[index].tax_amount = tax_amount ? tax_amount : "0.000";
          data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

          let subtotal =
            data?.reduce(
              (acc, currentValue) =>
                parseFloat(acc) + parseFloat(currentValue?.total),
              0
            ) -
            data?.reduce(
              (acc, currentValue) =>
                parseFloat(acc) + parseFloat(currentValue?.tax_amount),
              0
            );

          let taxamount = data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.tax_amount),
            0
          );

          let grandtotal = data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.total),
            0
          );

          totals.subtotal = subtotal;
          totals.taxamount = taxamount;
          totals.total = grandtotal;

          setDetails(data);
          setTotals({ ...totals });
        }
      }
    }
  };


  const handleChange = (e, index, key) => {
    let data = [...details];

    data[index][e?.target?.name] = e?.target?.value;
    setDetails(data);
  };

  const handleSalePrice = (e, index) => {
    if (e?.target?.value >= 0) {
      let data = [...details];

      data[index].sale_price = e?.target?.value;

      if (data[index]?.unit_details_options?.length > 0) {
        data[index]?.unit_details_options?.map((v, i) => {
          data[index].unit_details_options[i].sale_price = (
            parseFloat(e?.target?.value) / parseFloat(v?.conversion)
          )?.toFixed(3);
        });
      }

      setDetails(data);
    }
  };

  const handleUnitSalePrice = (e, index, i) => {
    let data = [...details];

    let name = e?.target?.name;
    let value = e?.target?.value;

    if (name) {
      if (value >= 0) {
        data[index].unit_details_options[i].sale_price = value;
        setDetails(data);
      }
    }
  };

  const handleDate = (e, index, name) => {
    let data = [...details];
    data[index][name] = e?.$d;

    setDetails(data);
  };

  const handleDelivered = (e, index) => {
    let data = [...details];

    let data_delivered = e?.target?.value ? parseFloat(e?.target?.value) : 0;

    let data_quantity = data[index]?.quantity
      ? parseFloat(data[index]?.quantity)
      : 0;
    let data_free = data[index]?.free ? parseFloat(data[index]?.free) : 0;
    let total_quantity =
      parseFloat(data_quantity || 0) + parseFloat(data_free || 0);

    if (data_delivered >= 0) {
      if (data_delivered <= total_quantity) {
        let unit_details_options = [];
        if (data?.[index]?.unit_details_options?.length > 0) {
          data?.[index]?.unit_details_options?.map((v, i) => {
            unit_details_options?.push({
              ...v,
              //delivered_stcok
              unit_delivered: data_delivered
                ? parseFloat(data_delivered) * parseFloat(v?.conversion)
                : 0,
            });
          });
        }

        data[index][e?.target?.name] = e?.target?.value;
        data[index].unit_details_options = unit_details_options;

        setDetails(data);
      } else {
        toast?.error(`Quantity only ${total_quantity}`);
      }
    }
  };

  const handleRemove = (index) => {
    let name = "quantity";
    let value = 0;

    if (value >= 0) {
      let data = [...details];

      // if (value <= data[index]?.stock) {
      let data_sale_price = data[index]?.sale_price
        ? data[index]?.sale_price
        : 0;
      let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
      let data_deliverd = data[index]?.delivered ? data[index]?.delivered : 0;
      let data_free = data[index]?.free ? data[index]?.free : 0;
      let data_tax = data[index]?.tax ? data[index]?.tax : 0;
      let data_conversion = data[index].conversion ? data[index].conversion : 0;

      let sale_price = name === "sale_price" ? value : data_sale_price;
      let quantity = name === "quantity" ? value : data_quantity;
      let delivered = name === "quantity" ? value : data_deliverd;
      let free = name === "free" ? value : data_free;
      let tax = name === "tax" ? value : data_tax;

      let tax_amount = tax
        ? parseFloat(sale_price) *
        parseFloat(quantity ? quantity : 0) *
        (parseFloat(tax) / 100)
        : 0;

      let total =
        parseFloat(sale_price) * parseFloat(quantity ? quantity : 0) +
        parseFloat(tax_amount);

      let price_per_unit =
        parseFloat(total ? total : 0) /
        (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

      let unit_details_options = [];
      if (data?.[index]?.unit_details_options?.length > 0) {
        data?.[index]?.unit_details_options?.map((v, i) => {
          let total_quantity =
            parseFloat(quantity || 0) + parseFloat(free || 0);

          unit_details_options?.push({
            ...v,
            //price_per_unit
            price_per_unit: price_per_unit
              ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
              : 0,
            //unit_quantity
            unit_quantity: quantity
              ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
              : 0,
            //unit_deliverd
            unit_delivered: delivered
              ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
              : 0,
          });
        });
      }

      if (
        data_conversion > 0 &&
        parseFloat(quantity) + parseFloat(free) >= data_conversion
      ) {
        toast?.error(`Quantiy exceeding ${data[index].conversion}`);
      } else {
        data[index][name] = value;
        data[index].unit_details_options = unit_details_options;
        data[index].delivered = delivered ? delivered : "";
        data[index].tax = tax ? tax : 0;
        data[index].total = total ? total : 0;
        data[index].tax_amount = tax_amount ? tax_amount : "0.000";
        data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

        let subtotal =
          data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.total),
            0
          ) -
          data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.tax_amount),
            0
          );

        let taxamount = data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.tax_amount),
          0
        );

        let grandtotal = data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0
        );

        totals.subtotal = subtotal;
        totals.taxamount = taxamount;
        // totals.delivery_status = 0;
        // totals.delivery_date = "";
        // totals.payment_status = 0;
        // totals.payment_types = null;
        // totals.payments = {
        //   Cash: "",
        //   Cheque: "",
        //   "Debit card": "",
        //   "Credit card": "",
        //   "Bank transfer": "",
        //   "Online payment": "",
        // };
        totals.total = grandtotal;

        data?.splice(index, 1);
        setDetails(data);
        setTotals({ ...totals });
      }
      // }
      // else {
      //   toast?.error(`Stock only ${data[index]?.stock}`);
      // }
    }

    // data?.splice(index, 1);

    // setDetails(data);
  };

  const handleAdd = () => {
    setDetails((prevDetails) => [
      ...prevDetails,
      {
        id: "",
        description: null,
        name: "",
        unit: "",
        unit_name: "",
        unit_details_options: null,
        quantity: "",
        purchase: "",
        sale_price: "",
        purchase_options: null,
        delivered: "",
        tax: 0,
        free: "",
        barcode: "",
        price_per_unit: "",
        sale_price: "",
        expiry_date: "",
        tax_amount: "0.000",
        total: 0,
      },
    ]);

    setTimeout(() => {
      focus.current[`description${details?.length}`].current.focus();
    }, 100);
  };

  const handleDelivery = (e) => {
    if (e?.target?.value >= 0) {
      let total_amount = parseFloat(
        details?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0
        )
      );

      let total =
        parseFloat(total_amount ? total_amount : 0) +
        parseFloat(e?.target?.value ? e?.target?.value : 0) -
        parseFloat(totals?.discount ? totals?.discount : 0);

      totals.delivery = e?.target?.value;
      totals.total = total;

      setTotals({ ...totals });
    }
  };

  const handleDiscount = (e) => {

    console.log("invoice data", invoiceData);

    if (e?.target?.value >= 0) {

      if (e?.target?.value > invoiceData.discount) {
        toast?.error(
          `Discount cannot exceed the original invoice discount (${invoiceData.discount}).`
        );
      } else {
        let total_amount = parseFloat(
          details?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.total),
            0
          )
        );

        let total =
          parseFloat(total_amount ? total_amount : 0) +
          parseFloat(totals?.delivery ? totals?.delivery : 0) -
          parseFloat(e?.target?.value ? e?.target?.value : 0);

        if (e?.target?.value <= total_amount) {
          totals.discount = e?.target?.value;
          totals.total = total;
        } else {
          toast?.error(`Total amount ${total_amount}`);
        }

        setTotals({ ...totals });
      }

    }
  };

  const handleDeliveryStatus = (e) => {
    totals.delivery_status = e;

    if (!e) {
      totals.delivery_date = "";
    } else if (e == 1) {
      totals.delivery_date = "";
    }

    setTotals({ ...totals });
  };

  const handleDeliveryDate = (e) => {
    totals.delivery_date = e?.$d;
    setTotals({ ...totals });
  };

  const handlePaymentStatus = (e) => {

    console.log("Rrrr", e)
    totals.payment_status = e;

    if (!e) {
      totals.payment_types = null;
    }
    setTotals({ ...totals });
  };

  const handlePaymentTypes = (e) => {
    totals?.payment_types?.map((v, i) => {
      if (!e?.includes(v)) {
        totals.payments[v] = "";
      }
    });

    totals.payment_types = e;

    setTotals({ ...totals });
  };

  /*   const handlePayments = (e) => {
      let name = e?.target?.name;
      let valueStr = e?.target?.value || "";   
      let value = valueStr === "" ? 0 : Number(valueStr);
      console.log("INPUT:", name, valueStr, value);
  
  
      if (value < 0) return;
      if (!totals.payments) {
        totals.payments = {
          Cash: { amount: 0 },
          Cheque: { amount: 0 },
          "Debit card": { amount: 0 },
          "Credit card": { amount: 0 },
          "Bank transfer": { amount: 0 },
          "Online payment": { amount: 0 }
        };
      }
  
      const data_Cash = totals?.payments?.Cash?.amount || 0;
      const data_Cheque = totals?.payments?.Cheque?.amount || 0;
      const data_Debitcard = totals?.payments?.["Debit card"]?.amount || 0;
      const data_Creditcard = totals?.payments?.["Credit card"]?.amount || 0;
      const data_Banktransfer = totals?.payments?.["Bank transfer"]?.amount || 0;
      const data_Onlinepayment = totals?.payments?.["Online payment"]?.amount || 0;
  
      const currentTotal = data_Cash + data_Cheque + data_Debitcard +
        data_Creditcard + data_Banktransfer + data_Onlinepayment;
  
      const newPaymentTotal = currentTotal - (totals?.payments?.[name]?.amount || 0) + value;
      const grand_total = totals?.total ? parseFloat(totals.total) : 0;
  
      console.log("Payment validation:", {
        newPaymentTotal,
        grand_total,
  
      });
  
      if (newPaymentTotal <= grand_total.toFixed(3)) {
        totals.payments[name] = {
          ...totals.payments[name],
          amount: value
        };
        setTotals({ ...totals });
      } else {
        const remainingAmount = grand_total - (currentTotal - (totals?.payments?.[name]?.amount || 0));
        toast?.error(`Maximum amount for ${name} is ${remainingAmount.toFixed(3)}`);
      }
    };
   */

  const handlePayments = (e) => {
    const name = e.target.name;
    let valueStr = e.target.value || "";


    if (valueStr === "") valueStr = "0";


    const isValidDecimal = /^\d*\.?\d*$/.test(valueStr);
    if (!isValidDecimal) return;


    const valueNum = parseFloat(valueStr) || 0;

    if (valueNum < 0) return;

    if (!totals.payments) {
      totals.payments = {
        Cash: { amount: 0 },
        Cheque: { amount: 0 },
        "Debit card": { amount: 0 },
        "Credit card": { amount: 0 },
        "Bank transfer": { amount: 0 },
        "Online payment": { amount: 0 }
      };
    }

    const currentTotal =
      Object.values(totals.payments).reduce((acc, curr) => acc + (curr.amount || 0), 0);

    const newPaymentTotal = currentTotal - (totals?.payments?.[name]?.amount || 0) + valueNum;
    const grand_total = totals?.total ? parseFloat(totals.total) : 0;

    if (newPaymentTotal <= grand_total) {
      totals.payments[name] = {
        ...totals.payments[name],
        amount: valueNum,
        valueStr
      };
      setTotals({ ...totals });
    } else {
      const remainingAmount = grand_total - (currentTotal - (totals?.payments?.[name]?.amount || 0));
      toast?.error(`Maximum amount for ${name} is ${remainingAmount.toFixed(3)}`);
    }
  };


  const handleBatchQuantityChange = (e, index, batchIndex) => {
    let data = [...details];
    const value = parseFloat(e.target.value) || 0;

    if (value < 0) {
      toast.error("Quantity cannot be negative");
      return;
    }

    const item = data[index];
    const unitDetail = item.unit_details_options[batchIndex];

    const conversion = unitDetail?.conversion || 1;
    const mainConversion = data[index].conversion || 1;

    const availableMainQty = parseFloat(
      item.max_available_qty
        ? item.max_available_qty
        : item.already_ordered_quantity
    );


    const availableMainQtyDisplay = mainConversion === 1
      ? availableMainQty * conversion
      : availableMainQty;

    console.log("Quantity Check:", availableMainQtyDisplay)

    const valueInMainUnits = value / conversion;

    if (value > availableMainQtyDisplay) {
      toast.error(
        `Only ${availableMainQtyDisplay} ${unitDetail.name} available!`
      );
      return;
    }

    item.unit_details_options[batchIndex].unit_quantity = value;

    item.quantity = valueInMainUnits;

    handleTotal({ target: { value: valueInMainUnits } }, index, "quantity");

    setDetails(data);
  };

  const dateFormatList = ["DD/MM/YYYY", "DD-MM-YYYY"];

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <div className="overflow-x-auto">
      <Modalcomponent
        open={open}
        setOpen={setOpen}
        modalData={modalData}
        setModalData={setModalData}
        selectedModalData={selectedModalData}
        setSelectedModalData={setSelectedModalData}
        handleModal={handleModal}
      />
      <table className="w-[100%]">
        <thead>
          <tr>
            <td className="border p-4 text-black">S.NO</td>
            <td className="border p-4 text-black">DESCRIPTION</td>
            <td className="border p-4 text-black">UNIT</td>
            <td className="border p-4 text-black">QUANTITY</td>
            {/* <td className="border p-4 text-black">DELIVERED</td> */}
            <td className="border p-4 text-black">SALE&nbsp;PRICE</td>
            <td className="border p-4 text-black">DISC</td>
            <td className="border p-4 text-black">FOC</td>
            <td className="border p-4 text-black">TAX&nbsp;[VAT]</td>
            <td className="border p-4 text-black">TOTAL</td>
            <td className="border p-4 text-black">DELETE</td>
          </tr>
        </thead>
        <tbody>
          {details?.map((value, index) => {
            focus.current[`description${index}`] = createRef();
            focus.current[`sale_price${index}`] = createRef();
            focus.current[`quantity${index}`] = createRef();
            return (
              <React.Fragment>
                <tr>
                  <td className="border p-4 text-center text-gray-700">
                    {index + 1}
                  </td>
                  <td className="border p-4">
                    {value?.description ? (
                      <div className="w-[300px]">
                        <div className="text-black">{value?.name}</div>
                        <div className="text-xs">{`#BATCH-${value?.batch}`}</div>
                        <div className="text-xs">
                          {value?.expiry_date
                            ? `Expiry (${formatDateDDMMYYYY(value?.expiry_date)})`
                            : ""}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Select
                          className="w-[300px] text-regular"
                          name="description"
                          ref={focus.current[`description${index}`]}
                          placeholder="Description"
                          allowClear={true}
                          showSearch={true}
                          filterOption={false}
                          value={value?.description}
                          options={value?.options}
                          onSearch={(e) => handleSearch(e, index)}
                          onFocus={(e) => handleSearch("", index)}
                          onClick={(e) => handleSearch("", index)}
                          onChange={(e) => handleDescription(e, index)}
                          autoComplete="off"
                        />
                      </div>
                    )}
                    <Error id={`description${index}`} />
                  </td>
                  <td className="border p-4 text-center">
                    <div>{value?.unit_name}</div>
                  </td>
                  <td className="border p-4 align-top">
                    <div className="flex flex-col items-start">
                      <div className="text-xs text-green-500">
                        {/* Stock&nbsp;({value?.stock?.toFixed?.(3)}) */}
                      </div>
                      <Input
                        type="number"
                        className="w-full text-regular"
                        name="quantity"
                        ref={focus.current[`quantity${index}`]}
                        placeholder="Quantity"
                        value={details[index]?.quantity || ""}
                        onChange={(e) => handleTotal(e, index, "quantity")}
                        autoComplete="off"
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => {
                          e.target.blur();
                        }}
                      />
                      <div>
                        <Error id={`quantity${index}`} />
                      </div>
                    </div>
                  </td>
                  {/* <td className="border p-4 text-center">
                    <Input
                      type="number"
                      className="w-full text-regular"
                      name="delivered"
                      placeholder="Delivered"
                      value={value?.delivered}
                      onChange={(e) => handleDelivered(e, index)}
                      autoComplete="off"
                    />
                  </td> */}
                  <td className="border p-4 text-center">
                    <div>
                      <div>
                        <AutoComplete
                          className="w-[150px] text-regular"
                          name="sale_price"
                          ref={focus.current[`sale_price${index}`]}
                          placeholder={`Sale price`}
                          allowClear={true}
                          showSearch={true}
                          filterOption={false}
                          options={value?.purchase_options}
                          value={value?.sale_price}
                          onClick={(e) => handlePurchasePriceSearch("", index)}
                          // onChange={(e) => handleTotal(e, index, "sale_price")}
                          autoComplete="off"
                        />
                        <Error
                          className="pt-0.5 text-xs text-red-500 text-left"
                          id={`sale_price${index}`}
                        />
                      </div>
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    <div>{value?.discount_percentage ? value?.discount_percentage + "%" : "0%"}</div>
                    <div>
                      {value?.discount_price
                        ? parseFloat(value?.discount_price)?.toFixed(3)
                        : "0.000"}
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    <Input
                      type="number"
                      className="w-[75px] text-regular"
                      name="free"
                      placeholder="FOC"
                      value={value?.free}
                      onChange={(e) => handleTotal(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4 text-center">
                    <div>{value?.tax ? value?.tax + "%" : "0%"}</div>
                    <div>
                      {value?.tax_amount
                        ? parseFloat(value?.tax_amount)?.toFixed(3)
                        : "0.000"}
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    {value?.total
                      ? parseFloat?.(value?.total)?.toFixed(3)
                      : "0.000"}
                  </td>
                  <td className="border p-4 text-center">
                    <button
                      type="button"
                      className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                      onClick={() => handleRemove(index)}
                    >
                      <DeleteOutlined />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-200 border-b-gray-400 p-4 text-center"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>

                  <td className="border border-gray-200 border-b-gray-400 p-4">
                    <div>
                      {value?.unit_details_options?.map((v, i) => {
                        return (
                          <div className="pt-2" key={i}>
                            <div className="pb-2 text-gray-700">
                              {v?.name}({v?.conversion})
                            </div>
                            <div>
                              <Input
                                type="number"
                                className="w-full text-regular"
                                placeholder={`Enter ${v?.name} quantity`}
                                value={v?.conversion * value?.quantity || ""}
                                onChange={(e) => handleBatchQuantityChange(e, index, i)}
                                autoComplete="off"
                                onKeyDown={(e) => {
                                  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                    e.preventDefault();
                                  }
                                }}
                                onWheel={(e) => {
                                  e.target.blur();
                                }}
                              />
                            </div>
                            <div className="text-xs text-gray-500 mt-1">
                              {(() => {
                                const availableMain =
                                  value?.max_available_qty
                                    ? value.max_available_qty
                                    : value?.already_ordered_quantity;

                                const unitDetail = value.unit_details_options[0];
                                const conversion = unitDetail?.conversion || 1;
                                const normalConversion = value?.conversion || 1;

                                const availableStripsDisplayQty =
                                  normalConversion === 1
                                    ? availableMain * conversion
                                    : availableMain;


                                const availableMainDisplay =
                                  normalConversion > 1
                                    ? availableMain / conversion
                                    : availableMain;

                                return (
                                  <>
                                    Available: {availableStripsDisplayQty} {unitDetail?.name}
                                    ({availableMainDisplay} main units)
                                  </>
                                );
                              })()}
                            </div>

                          </div>
                        );
                      })}
                    </div>
                  </td>

                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td
                    className="border border-gray-200 border-b-gray-400 p-4 text-center"
                    colSpan={1}
                  ></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                  <td className="border border-gray-200 border-b-gray-400 p-4"></td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td className="border p-4" rowSpan={2} colSpan={7}></td>
            <td className="border p-4" rowSpan={2} colSpan={3}>
              <div className="text-center">
                <AddButton
                  className={"form-save-button w-full h-full text-center"}
                  onClick={handleAdd}
                />
              </div>
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td className="border p-4" colSpan={7}></td>
            <td className="border p-4 text-gray-700">SUBTOTAL</td>
            <td className="border p-4" colSpan={2}>
              {totals?.subtotal > 0 ? totals?.subtotal?.toFixed(3) : "0.000"}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={7}></td>
            <td className="border p-4 text-gray-700">TAX&nbsp;[VAT]</td>
            <td className="border p-4" colSpan={2}>
              {totals?.taxamount > 0 ? totals?.taxamount?.toFixed(3) : "0.000"}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={7}></td>
            <td className="border p-4 text-gray-700">DISCOUNT&nbsp;</td>
            <td className="border p-4" colSpan={2}>
              <Input
                type="number"
                className="w-full"
                placeholder="Discount amount"
                name="discount"
                value={totals?.discount}
                autoComplete="off"
                onChange={handleDiscount}
                onKeyDown={(e) => {
                  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                    e.preventDefault();
                  }
                }}
                onWheel={(e) => {
                  e.target.blur();
                }}
              />
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={7}></td>
            <td className="border p-4 text-gray-700">DELIVERY&nbsp;</td>
            <td className="border p-4" colSpan={2}>
              <Input
                type="number"
                className="w-full"
                placeholder="Delivery charges"
                name="delivery"
                value={totals?.delivery}
                autoComplete="off"
                onChange={handleDelivery}
                onKeyDown={(e) => {
                  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                    e.preventDefault();
                  }
                }}
                onWheel={(e) => {
                  e.target.blur();
                }}
              />
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={7}></td>
            <td className="border p-4 text-gray-700">DELIVERY&nbsp;STATUS</td>
            <td className="border p-4" colSpan={2}>
              <div>
                <div>
                  <Select
                    className="w-full"
                    name="tax"
                    placeholder="Delivery status"
                    value={totals?.delivery_status}
                    options={[
                      {
                        value: 0,
                        label: "Pending",
                      },
                      {
                        value: 1,
                        label: "Partial",
                      },
                      {
                        value: 2,
                        label: "Delivered",
                      },
                    ]}
                    onChange={handleDeliveryStatus}
                  />
                </div>
                {/* {focus.current[`delivery_date`] = createRef()} */}
                {totals?.delivery_status == 2 && (
                  <div className="pt-4">
                    <DatePicker
                      format={dateFormatList}
                      type="number"
                      name="delivery_date"
                      ref={focus.current[`delivery_date`]}
                      className="w-full"
                      placeholder="Delivered date"
                      value={
                        totals?.delivery_date && dayjs(totals?.delivery_date)
                      }
                      onChange={handleDeliveryDate}
                      autoComplete="off"
                      onKeyDown={handleDateKeyDown}
                      onInput={handleDateInput}
                      onPaste={blockPaste}
                      onBlur={(e) =>
                        handleDateBlur(e, (date) => handleDeliveryDate({ $d: date }))
                      }
                    />
                    <Error id={`delivery_date`} />
                  </div>
                )}
              </div>
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={7}></td>
            <td className="border p-4 text-gray-700">PAYMENT&nbsp;STATUS</td>
            <td className="border p-4" colSpan={2}>
              <div>
                <Select
                  className="w-full"
                  name="tax"
                  placeholder="Payment status"
                  value={totals?.payment_status}
                  options={[
                    {
                      value: 0,
                      label: "Unpaid",
                    },
                    {
                      value: 1,
                      label: "Partial",
                    },
                    {
                      value: 2,
                      label: "Paid",
                    },
                  ]}
                  onChange={handlePaymentStatus}
                />
              </div>
              {totals?.payment_status == 1 || totals?.payment_status == 2 ? (
                <div className="pt-4">
                  <Select
                    mode="multiple"
                    className="w-full"
                    name="payment_types"
                    ref={focus.current[`payment_types`]}
                    placeholder="Payment types"
                    value={totals?.payment_types}
                    options={payment_types}
                    onChange={handlePaymentTypes}
                  />
                  <Error id={`payment_types`} />
                </div>
              ) : (
                ""
              )}
              {totals?.payment_types?.map((value, index) => {
                focus.current[`${value}`] = createRef();
                return (
                  <div key={`payment-${value}-${index}`} className="pt-4">
                    <Input
                      type="text"
                      className="w-full"
                      placeholder={value}
                      name={value}
                      ref={focus.current[`${value}`]}
                      value={totals?.payments?.[value]?.valueStr || totals?.payments?.[value]?.amount || ""}
                      onChange={handlePayments}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />

                    <Error id={`${value}`} />
                  </div>
                );
              })}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={7}></td>
            <td className="border p-4 text-black text-medium">TOTAL</td>
            <td className="border p-4 text-black text-medium" colSpan={2}>
              {totals?.total > 0 ? totals?.total?.toFixed(3) : "0.000"}
            </td>
          </tr>
        </tfoot>
      </table>
      {/* <div className="flex justify-end p-3">
        <AddButton onClick={handleAdd} />
      </div> */}
    </div>
  );
});

export default Salesreturntable;
